import { Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Events, NavController, NavParams, ToastController } from "ionic-angular";
import { ModalController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { ListComponent } from "../../components/listcomponent/listcomponent";
import { Member } from "../../models/interfaces/member.model";
import { Role } from "../../models/interfaces/role.model";
import { CommitteePage } from "../../pages/committee/committee";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-committeemember_add",
  templateUrl: "committeemember_add.html",
})
export class CommitteeMemberAddPage {
  public static readonly COM_ADD_ACCESS = "addCommittee";
  private hasAddCommitteeAccess: boolean = false;
  private role$: Observable<Role[]>;
  private groupmembers;
  private tempgrpmembers;
  private member$: any;
  private committeememberForm: FormGroup;
  private member: Member;
  private items: string[];
  private smember: string;
  private styleName: string ="";
  private smemberM: Member[];
  private co_id;
  private roItem;
  constructor(private configService: ConfigService,public authService: AuthService,public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, private toastCtrl: ToastController
    ,         private db: DbserviceProvider, public events: Events, public modalCtrl: ModalController,
  ) {
    console.log("CommitteeMemberAddPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");

    if (this.authService.currentUser) {
      this.authService.currentUser.subscribe(
        (user) => {
          //this.currentUser = user;
          this.hasAddCommitteeAccess = this.db.hasAccess(CommitteePage.COM_ADD_ACCESS);
          console.log("CommitteePage this.hasAddCommitteeAccess", this.hasAddCommitteeAccess);
        },
      );
    }

    console.error("this.navParams.get(committee)",this.navParams.get("committee"));
    this.co_id = this.navParams.get("committee").co_id;
    this.committeememberForm = this.formBuilder.group({
      "cm_sort": [""],
      "co_id": [""],
      "mb_id": [""],
      "ref_mb": [""],
      "ro_id": [""],
      "ro_name": [""],
    });
    this.committeememberForm.controls.co_id.setValue(this.co_id);
  }

  private ionViewWillEnter() {
    console.log("CommitteeMemberAddPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("CommitteeMemberAddPage onInitPage");
    if (this.hasAddCommitteeAccess) {
      this.role$ = this.db.dbCol({
        "action": "select", "mapObject": "role"
      });
    } else {
      this.role$ = this.db.dbCol({
        "action": "select", "mapObject": "role",
        "sqlExtended": "where ro_name!='Admin' order by ro_id"
      });
    }
  }

  private goback() {
    console.log("CommitteeMemberAddPage goback");
    this.navCtrl.pop();
  }
  private selectMember(val) {
    console.log("HarelineAddPage selectHareList");
    let selection = this.modalCtrl.create(ListComponent, { "obs": "member", "sel": val, "type": "S" });

    selection.present();
    selection.onDidDismiss((data) => {
      if (data != null) {
        if (data !== null) {
          this.smemberM = data;
          this.smember = data.map(v => v.mb_hashname).toString();
        }
      }
    });
  }
  private addCommitteeMember(value: any) {
    console.log("CommitteeMemberAddPage addCommitteeMember " + this.smemberM[0].id);
    this.db.dbCol({
      "action": "select", "mapObject": "committee_member", "sqlExtended": " where committee_member.co_id= '" + this.co_id + "' and  committee_member.mb_id = '" + <any>this.smemberM[0].mb_id + "'"
    })
      .subscribe((ret1) => {
        if (ret1.length === 0) {
          // this is a new committee member
          this.db.dbCol({ "action": "insert", "mapObject": "committee_member", "co_id": this.co_id,  "mb_id": <any>this.smemberM[0].mb_id })
            .subscribe((ret2) => {
              this.db.dbCol({ "action": "insert", "mapObject": "committee_member_role", "cm_id": ret2.id, "ro_id": this.committeememberForm.value.ro_id })
                .subscribe((ret3) => {
                  this.navCtrl.pop();
                });
            });
        }
        else {
          // member is already in the committee and takes additional roles
          this.db.dbCol({ "action": "dml", "mapObject": "dml", "query": "DELETE FROM committee_member_role WHERE committee_member_role.cm_id=" + ret1[0].cm_id + " and ro_id=" + this.committeememberForm.value.ro_id })
            .subscribe((ret3) => {
              this.db.dbCol({ "action": "insert", "mapObject": "committee_member_role", "cm_id": ret1[0].cm_id, "ro_id": this.committeememberForm.value.ro_id })
                .subscribe((ret2) => {
                  this.navCtrl.pop();
                });
            });
        }
      });
  }
  private ngOnDestroy() {
    console.log("CommitteeMemberAddPage ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./src/pages/committee/committeemember_add.ts